import React from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
const cx = cls(styles);

const sceneList = [
	{
		scene: 'https://web-data.zmlearn.com/image/2n8KXDM3aZ4Z3ePtj8sTjW/convenient_1%402x.png',
		title: 'More convenient',
		description: 'Only you need is your PC/iPad',
	},
	{
		scene: 'https://web-data.zmlearn.com/image/9tN8x1EEtSLxv3WCBys8Eo/convenient_2%402x.png',
		title: 'More efficient',
		description: 'Real-time class interaction and ready for Q&A during the class',
	},
	{
		scene: 'https://web-data.zmlearn.com/image/sfRcBmv3Mbci4YkJXHGF85/convenient_3%402x.png',
		title: 'More intelligent',
		description: 'Automatic recording and always available for review',
	},
];
/**
 * 多场景使用模块
 * @returns
 */
export default function AppraisalBox() {
	return (
		<div className={cx('scene-block')}>
			<Section>
				<h3 className={cx('scene-title block-title')}>Online 1-on-1 class, anywhere and anytime</h3>
				<div className={cx('scene-list', 'scroll-view')}>
					{sceneList.map((item, idx) => {
						return (
							<dl className={cx('scene-item')} key={idx}>
								<dt>
									<img src={item.scene} alt="" loading='lazy' />
								</dt>
								<dd className={cx('scene-title')}>{item.title}</dd>
								<dd>{item.description}</dd>
							</dl>
						);
					})}
				</div>
			</Section>
		</div>
	);
}
